import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Card from "../../Elements/Card";
import Footer, { FooterTab, MobileFooter } from "../GreenHome/Footer";
import useFindDevice from "../CustomHooks/FindDevice";
import Navbar from "../../_V2/Pages/RoundToJoin/navbar";
import { pnpLogo } from "../../_V2/Asserts";

function Rulse() {
  const navigate = useNavigate();
  const { isMob, isTab, isLaptop, isLogedIn } = useFindDevice();
  const [userInfo, setUserInfo] = useState(null);
  const [selectedNav, setSelectedNav] = useState("");
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserInfo(parsedUserInfo?.userLogedIn);
      } catch (error) {
        setUserInfo(null);
      }
    } else {
      setUserInfo(null);
    }
  }, []);

  const redirectToLogin = () => {
    navigate("/login");
  };

  const redirectToRegister = () => {
    navigate("/signup");
  };

  const redirectHome = () => {
    navigate("/");
  };

  const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));
  return (
    <>
      {
        storedUserInfo?.email && <Navbar
          setDropdownOpen={setDropdownMenuOpen}
          setSelectedNav={setSelectedNav}
          selectedNav={selectedNav}
          setMobileMenuOpen={setMobileMenuOpen}
          setDropdownPos={setDropdownPos}
          dropdownPos={dropdownPos}
          dropdownOpen={dropdownMenuOpen}
          mobileMenuOpen={mobileMenuOpen}
          setOtherMenusOpen={setOtherMenusOpen}
          otherMenusOpen={otherMenusOpen}
        />
      }


      {isMob === true ? (
        <div
          className={`font-interFont overflow-auto ${isMob === true
            ? "bg-[url('../public/v2/images/bg/auth-bg-mobile.png')]"
            : "bg-[url('../public/v2/images/bg/auth-bg.png')]"
            } bg-cover`}
        >
          <div className="mb-[10px] mobile-s:h-[750px] mobile-l:h-[850px] w-full px-2 py-5 font-Inter">
            {!storedUserInfo?.email && (
              <div className="flex w-full p-2 justify-between items-center border-b border-[#D3D3D31F] mx-auto">
                <div className="flex-shrink-0">
                  <img 
                    src={pnpLogo} 
                    alt="pickNdPrizes" 
                    onClick={redirectHome}
                    className="h-12 w-auto cursor-pointer"
                  />
                </div>
                <div className="text-[10px] font-[400] font-roboto flex gap-1 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[8px] py-[6px] px-[8px] rounded-[20px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[8px] py-[6px] px-[6px] rounded-[20px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}
            <div>
              <div className={`px-2 rules-top ${storedUserInfo?.email ? 'mt-24' : 'mt-2'}`}>
                <h2 className="text-[#FFFFFF] text-[24px] text-center">
                  Responsible Gaming
                </h2>
              </div>

              {/* <Card className="mx-2 h-[85.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <h4 className="text-[18px] mt-[3%] text-[#000000] font-semibold">
                  Responsible Gaming of Sportspik (the game)
                </h4>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  1. By accepting the Terms and Conditions, you agree to the
                  Competition responsible gaming, and it will be legally binding on you.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  2. The responsible gaming of Sportspik are the same for all Sportspik
                  games.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  3. The entry fee and the prize money for each round of
                  Sportspik are pre-determined before the start of the round.
                  The aggregate of all the entry fees in a particular round
                  minus a 10% administrative fee will make up the prize money or
                  the jackpot of that round.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  4. Using each account a participant can join any Sportspik
                  round with one or two picks. Two is the maximum per
                  participant in a single round.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  5. If a participant is playing with two picks each pick is
                  treated completely independently in terms of playing the game.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  6. The participant shall join any round (active/open round) of
                  the competition up until the deadline of that round. The
                  deadline of each round and each match week within the round is
                  set at 1 hour prior to the commencement of the first match in
                  that match week.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  7. The objective of the game is to assign each of your picks
                  to a team in that week’s fixture list who the participant
                  thinks they win their match. If the selected team wins their
                  match that pick progresses to the following match week. If the
                  selected team draws or loses their match, then that pick is
                  eliminated.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  Example: Pick 1: Arsenal, and Pick 2: Liverpool. Arsenal draw
                  and Liverpool win then Pick 1 is eliminated and Pick 2
                  progresses.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  If your pick is successful, then you progress to the following
                  week and must repeat the process.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  8. Once a team is picked it cannot be chosen again under the
                  same pick until the round is over.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  Example: Since Pick 2 above selected Liverpool and they won
                  their match, then that player can no longer choose Liverpool
                  under Pick 2 for the rest of the round.
                </p>

                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  9. Once again, and as indicated in point 5.4 above, if a
                  participant is playing in a round with two picks, then they
                  are treated independently.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  Using the same example in point 6 above, let’s assume both
                  Arsenal & Liverpool have won their respective matches, in that
                  case Pick 1 will no longer be able to choose Arsenal again
                  until the round is over, however Pick 2 can still use Arsenal
                  since it hasn’t been used before.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  Consequently, since the two entries are treated independently
                  a player can pick the same team for both their picks as long
                  as he hasn’t used them previously in the same round.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  10. If a pick is not submitted before the deadline, that pick
                  will automatically be assigned to the lowest ranked team in
                  the league table that is available for that pick. If a
                  participant is playing with two picks and misses the deadline
                  on both, then one pick will be assigned to the lowest ranked
                  team available from the league table while the second pick
                  will be assigned to the second to last available team.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  Example: Sheffield and Burnley are ranked 20th and 19th in the
                  Premier League coming into the match week. A participant who
                  is playing with two picks misses the deadline. In that case,
                  Pick 1 will automatically select Sheffield while Pick 2 will
                  automatically select Burnley. Let’s assume that participant
                  had already picked Burnley under Pick 2 in a prior match week
                  within that same round. In that case Pick 2 will automatically
                  select the 18th ranked team in the table and so on.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  11. Each pick is only allowed one default per round. The
                  second default within the same round will result in automatic
                  elimination.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  12. Once a pick is made it can be changed up till the deadline
                  of that match week.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  13. If a match is postponed prior to the deadline lapsing the
                  player must re-pick by choosing a team from the remaining
                  fixtures that match week. If the match is postponed after the
                  deadline has passed, then any picks for that fixture will be
                  deemed successful and the players involved will not be allowed
                  to pick those same teams again in that round.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  14. Any matches played out of the normal schedule or that were
                  previously postponed will not be part of the fixtures to
                  select from and will be ignored.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  15. A match week will only be considered for selection if it
                  has a minimum of 8 fixtures. Match weeks that have less will
                  be skipped in the schedule.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  16. The Company reserves the right, in its sole discretion, to
                  refuse to accept participation that is incomplete,
                  indecipherable, offensive, does not comply with these T&Cs, or
                  contravenes any applicable laws or regulation.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  17. The Company reserves the right, in its sole discretion, to
                  disqualify any participant's account who has breached any of
                  these T&Cs, has engaged in unlawful or improper conduct or
                  otherwise acts to cheat or undermine the fairness of the
                  Competition/s by, for example, tampering with, or using or
                  exploiting errors in, the participation process to obtain a
                  competitive advantage over other entrants.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  18. SureShotSports FZ-LLC, if necessary to do so, reserve the
                  right to suspend, amend, void, or even cancel a game. This may
                  be necessary for reasons beyond our reasonable control
                  including, but not limited to strike, labour dispute,
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  illness, act of God, natural disaster, adverse weather
                  conditions, war, riot, accident, public health concern in
                  relation to potential infection, epidemic or pandemic,
                  malicious damage, fire, flood and/or storm, compliance with
                  law or governmental order, rule, regulation or direction,
                  breakdown of plant, machinery, or transportation. SSS are not
                  responsible for any loss or damage caused to you as a result
                  of any of these occurrences.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  19. The eligibility to participate is solely at the discretion
                  of the Company and we reserve the right to block or not accept
                  any registration.
                </p>
                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  20. The Company assumes no responsibility for any failure to
                  receive participation or for inaccurate information or any
                  loss, damage, or injury because of technical or
                  telecommunications problems, including security breaches. If
                  such problems arise, the Company may (where necessary with the
                  approval of the relevant authority) modify, cancel, terminate,
                  or suspend the Competition/s.
                </p>

                <p className="text-[12px] mt-[1%] text-[#0000005A] font-semibold">
                  21. Sportspik Champions League
                </p>

                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.1 With the exception of the below deviations, all other
                  responsible gaming from traditional Sportspik apply.
                </p>

                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.2 Unlike normal league based Sportspik competitions, the
                  Champions League version of Sportspik will be initially based
                  on a league system. After the first round of 8 match weeks the
                  game will be based on a knock-out system..
                </p>

                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.3 During the first eight match weeks players will be able
                  to make their selections among the 36 clubs involved.
                </p>
                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.4 After match week eight, match week 9 & 10 will be the two
                  legs of the play-off which will be between the teams who
                  finished 9th -24th in the table. This means that your
                  selections will be restricted to those 16 teams.
                </p>
                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.5 Match week 11 and beyond will be based on the 16 teams
                  that have qualified to the round of 16. These will include the
                  8 top teams after match week 8 in addition to the 8 teams
                  qualified from match week 9 & 10 play-off.
                </p>

                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.6 Regardless of how many picks remain alive the game ends
                  after the second leg of the quarter-finals. The semi-finals
                  and final will not be included in the game.
                </p>
                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.7 Each leg of each play-off & knock out stage will be
                  considered a separate match week. For example leg 1 of the
                  round of 16 is one match week while leg 2 is another.
                </p>

                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.8 Should we have more than one pick remaining after the
                  second leg of the quarter final the jackpot will be
                  distributed equally among the remaining picks
                </p>
                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.9 There could be a situation where players are still alive
                  at the quarter final stage and have no teams to pick from. For
                  Example, the 8 teams who qualified to the quarter final had
                  already been selected in prior match weeks by the player. In
                  this case when a player has no teams available to pick from
                  he/she will be automatically eliminated. Accordingly players
                  must be very careful in making their selections early so as to
                  ensure they have options during the quarter finals.
                </p>
                <p className="text-[12px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.10 Defaults at every stage will be based on the table
                  ranking in the first 8 match weeks. During the play-off &
                  knock-out a default will be assigned based on the lowest rank
                  team playing in these round as per the ranking after match
                  week 8.
                </p>
              </Card> */}

              {/* <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Play Responsibly – Stay in Control
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
                </p>
                  <h2 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  Age Verification – 18+  
                </h2>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
                </p>
                <div class="max-w-2xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6">
                  <h2 class="text-2xl font-bold text-gray-800">Keep in Control – Play Smart</h2>
                  <p class="text-gray-600">
                    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                  </p>

                  <div class="space-y-4">
                    <div class="border-l-4 border-blue-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Play for fun, not for income</h3>
                      <p class="text-sm text-gray-600">Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.</p>
                    </div>

                    <div class="border-l-4 border-green-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Stick to your budget</h3>
                      <p class="text-sm text-gray-600">Never spend more than you can afford to lose. SportsPik sets a <strong className="text-[#000000] font-semibold">max of 200 tokens per round</strong> to support responsible play.</p>
                    </div>

                    <div class="border-l-4 border-red-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Don’t chase losses</h3>
                      <p class="text-sm text-gray-600">Losing is part of the game, don’t try to win it back by playing more.</p>
                    </div>

                    <div class="border-l-4 border-yellow-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Monitor your time</h3>
                      <p class="text-sm text-gray-600">Track how long you play and take regular breaks.</p>
                    </div>

                    <div class="border-l-4 border-purple-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Avoid playing under stress or influence</h3>
                      <p class="text-sm text-gray-600">Gaming while upset or under the influence can lead to poor decisions.</p>
                    </div>

                    <div class="border-l-4 border-pink-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Know when to seek help</h3>
                      <p class="text-sm text-gray-600">If playing stops being fun or starts affecting your life, support is available.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 class="font-semibold text-gray-700">Timeout </h3>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                  </p>
                </div>
                <div>
                  <div class="max-w-xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-4">
                    <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                    <ul class="list-disc list-inside text-gray-700 space-y-2">
                      <li>
                        You cannot <span class="font-semibold text-red-600">buy tokens</span> or access your account.
                      </li>
                      <li>
                        You will not receive any <span class="font-semibold text-blue-600">SportsPik marketing communication</span>.
                      </li>
                    </ul>
                  </div>
                </div>

              </Card> */}
              {/* <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Play Responsibly – Stay in Control
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
                </p>
                <h2 className="text-[18px] mt-[3%] text-[#000000] font-semibold">
                  Age Verification – 18+  
                </h2>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
                </p>
                
                <div class="pt-3 bg-white  space-y-4">
  <h2 class="text-[22px] text-[#000000] font-semibold">Keep in Control – Play Smart</h2>
  <p class="text-gray-600">
    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
  </p>

  <ul class="list-disc pl-16 space-y-3 text-gray-700 text-[15px]">
    <li>
      <strong>Play for fun, not for income</strong><br />
      Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.
    </li>
    <li>
      <strong>Stick to your budget</strong><br />
      Never spend more than you can afford to lose. SportsPik sets a <strong class="text-black">max of 200 tokens per round</strong> to support responsible play.
    </li>
    <li>
      <strong>Don’t chase losses</strong><br />
      Losing is part of the game, don’t try to win it back by playing more.
    </li>
    <li>
      <strong>Monitor your time</strong><br />
      Track how long you play and take regular breaks.
    </li>
    <li>
      <strong>Avoid playing under stress or influence</strong><br />
      Gaming while upset or under the influence can lead to poor decisions.
    </li>
    <li>
      <strong>Know when to seek help</strong><br />
      If playing stops being fun or starts affecting your life, support is available.
    </li>
  </ul>
</div>

                <div className="pt-3">
                  <h3 class="text-[22px] text-[#000000] font-semibold">Timeout </h3>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                  </p>
                </div>
                <div>
                  <div class="bg-white space-y-4 pt-2">
                    <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                    <ul class="list-disc list-inside text-gray-700 space-y-2">
                      <li>
                        You cannot <span class="font-semibold text-red-600">buy tokens</span> or access your account.
                      </li>
                      <li>
                        You will not receive any <span class="font-semibold text-blue-600">SportsPik marketing communication</span>.
                      </li>
                    </ul>
                  </div>
                </div>

              </Card> */}
              <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Play Responsibly – Stay in Control
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
                </p>
                <h2 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Age Verification – 18+
                </h2>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
                </p>
                {/* <div class="max-w-2xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6">
                  <h2 class="text-2xl font-bold text-gray-800">Keep in Control – Play Smart</h2>
                  <p class="text-gray-600">
                    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                  </p>

                  <div class="space-y-4">
                    <div class="border-l-4 border-blue-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Play for fun, not for income</h3>
                      <p class="text-sm text-gray-600">Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.</p>
                    </div>

                    <div class="border-l-4 border-green-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Stick to your budget</h3>
                      <p class="text-sm text-gray-600">Never spend more than you can afford to lose. SportsPik sets a <strong className="text-[#000000] font-semibold">max of 200 tokens per round</strong> to support responsible play.</p>
                    </div>

                    <div class="border-l-4 border-red-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Don’t chase losses</h3>
                      <p class="text-sm text-gray-600">Losing is part of the game, don’t try to win it back by playing more.</p>
                    </div>

                    <div class="border-l-4 border-yellow-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Monitor your time</h3>
                      <p class="text-sm text-gray-600">Track how long you play and take regular breaks.</p>
                    </div>

                    <div class="border-l-4 border-purple-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Avoid playing under stress or influence</h3>
                      <p class="text-sm text-gray-600">Gaming while upset or under the influence can lead to poor decisions.</p>
                    </div>

                    <div class="border-l-4 border-pink-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Know when to seek help</h3>
                      <p class="text-sm text-gray-600">If playing stops being fun or starts affecting your life, support is available.</p>
                    </div>
                  </div>
                </div> */}
                <div class="pt-3 bg-white  space-y-4">
                  <h2 class="text-[22px] text-[#000000] font-semibold">Keep in Control – Play Smart</h2>
                  <p class="text-gray-600 text-[17px]">
                    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                  </p>

                  <ul class="list-disc pl-16 space-y-3 text-gray-700 text-[17px]">
                    <li>
                      <strong>Play for fun, not for income</strong><br />
                      Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.
                    </li>
                    <li>
                      <strong>Stick to your budget</strong><br />
                      Never spend more than you can afford to lose. SportsPik sets a <strong class="text-black">max of 200 tokens per round</strong> to support responsible play.
                    </li>
                    <li>
                      <strong>Don’t chase losses</strong><br />
                      Losing is part of the game, don’t try to win it back by playing more.
                    </li>
                    <li>
                      <strong>Monitor your time</strong><br />
                      Track how long you play and take regular breaks.
                    </li>
                    <li>
                      <strong>Avoid playing under stress or influence</strong><br />
                      Gaming while upset or under the influence can lead to poor decisions.
                    </li>
                    <li>
                      <strong>Know when to seek help</strong><br />
                      If playing stops being fun or starts affecting your life, support is available.
                    </li>
                  </ul>
                </div>

                <div className="pt-3">
                  <h3 class="text-[22px] text-[#000000] font-semibold">Timeout </h3>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                  </p>
                </div>
                <div>
                  <div class="bg-white space-y-4 pt-2">
                    <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                    <ul class="list-disc list-inside text-gray-700 space-y-2 text-[17px]">
                      <li>
                        You cannot buy tokens or access your account.
                      </li>
                      <li>
                        You will not receive any SportsPik marketing communication.
                      </li>
                    </ul>
                  </div>
                </div>

              </Card>
            </div>
          </div>

          <MobileFooter />
        </div>
      ) : isTab ? (
        <div className="overflow-auto bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover h-[100vh]">
          <div className="h-[100vh] w-full p-5 font-Inter">
            {!storedUserInfo?.email && (
              <div className="flex w-full px-3 pb-5 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
                <div className="flex-shrink-0">
                  <img 
                    src={pnpLogo} 
                    alt="pickNdPrizes" 
                    onClick={redirectHome}
                    className="h-20 cursor-pointer"
                  />
                </div>
                <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}

            {/* <div> */}
            <div className={`rules-top ${storedUserInfo?.email ? 'mt-[2%]' : 'mt-10'}`}>
              <h2 className="text-[#FFFFFF] text-[48px] text-center font-interFont">
                Responsible Gaming
              </h2>
            </div>

            {/* <Card className="m-auto h-[70vh] font-interFont overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
              <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                Responsible Gaming of Sportspik (the game)
              </h4>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                1. By accepting the Terms and Conditions, you agree to the
                Competition responsible gaming, and it will be legally binding on you.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                2. The responsible gaming of Sportspik are the same for all Sportspik games.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                3. The entry fee and the prize money for each round of Sportspik
                are pre-determined before the start of the round. The aggregate
                of all the entry fees in a particular round minus a 10%
                administrative fee will make up the prize money or the jackpot
                of that round.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                4. Using each account a participant can join any Sportspik round
                with one or two picks. Two is the maximum per participant in a
                single round.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                5. If a participant is playing with two picks each pick is
                treated completely independently in terms of playing the game.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                6. The participant shall join any round (active/open round) of
                the competition up until the deadline of that round. The
                deadline of each round and each match week within the round is
                set at 1 hour prior to the commencement of the first match in
                that match week.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                7. The objective of the game is to assign each of your picks to
                a team in that week’s fixture list who the participant thinks
                they win their match. If the selected team wins their match that
                pick progresses to the following match week. If the selected
                team draws or loses their match, then that pick is eliminated.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                Example: Pick 1: Arsenal, and Pick 2: Liverpool. Arsenal draw
                and Liverpool win then Pick 1 is eliminated and Pick 2
                progresses.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                If your pick is successful, then you progress to the following
                week and must repeat the process.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                8. Once a team is picked it cannot be chosen again under the
                same pick until the round is over.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                Example: Since Pick 2 above selected Liverpool and they won
                their match, then that player can no longer choose Liverpool
                under Pick 2 for the rest of the round.
              </p>

              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                9. Once again, and as indicated in point 5.4 above, if a
                participant is playing in a round with two picks, then they are
                treated independently.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                Using the same example in point 6 above, let’s assume both
                Arsenal & Liverpool have won their respective matches, in that
                case Pick 1 will no longer be able to choose Arsenal again until
                the round is over, however Pick 2 can still use Arsenal since it
                hasn’t been used before.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                Consequently, since the two entries are treated independently a
                player can pick the same team for both their picks as long as he
                hasn’t used them previously in the same round.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                10. If a pick is not submitted before the deadline, that pick
                will automatically be assigned to the lowest ranked team in the
                league table that is available for that pick. If a participant
                is playing with two picks and misses the deadline on both, then
                one pick will be assigned to the lowest ranked team available
                from the league table while the second pick will be assigned to
                the second to last available team.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                Example: Sheffield and Burnley are ranked 20th and 19th in the
                Premier League coming into the match week. A participant who is
                playing with two picks misses the deadline. In that case, Pick 1
                will automatically select Sheffield while Pick 2 will
                automatically select Burnley. Let’s assume that participant had
                already picked Burnley under Pick 2 in a prior match week within
                that same round. In that case Pick 2 will automatically select
                the 18th ranked team in the table and so on.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                11. Each pick is only allowed one default per round. The second
                default within the same round will result in automatic
                elimination.
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                12. Once a pick is made it can be changed up till the deadline
                of that match week.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                13. If a match is postponed prior to the deadline lapsing the
                player must re-pick by choosing a team from the remaining
                fixtures that match week. If the match is postponed after the
                deadline has passed, then any picks for that fixture will be
                deemed successful and the players involved will not be allowed
                to pick those same teams again in that round.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                14. Any matches played out of the normal schedule or that were
                previously postponed will not be part of the fixtures to select
                from and will be ignored.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                15. A match week will only be considered for selection if it has
                a minimum of 8 fixtures. Match weeks that have less will be
                skipped in the schedule.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                16. The Company reserves the right, in its sole discretion, to
                refuse to accept participation that is incomplete,
                indecipherable, offensive, does not comply with these T&Cs, or
                contravenes any applicable laws or regulation.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                17. The Company reserves the right, in its sole discretion, to
                disqualify any participant's account who has breached any of
                these T&Cs, has engaged in unlawful or improper conduct or
                otherwise acts to cheat or undermine the fairness of the
                Competition/s by, for example, tampering with, or using or
                exploiting errors in, the participation process to obtain a
                competitive advantage over other entrants.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                18. SureShotSports FZ-LLC, if necessary to do so, reserve the
                right to suspend, amend, void, or even cancel a game. This may
                be necessary for reasons beyond our reasonable control
                including, but not limited to strike, labour dispute,
              </p>
              <p className="text-[15px] mt-[1%] font-interFont text-[#0000005A] font-semibold">
                illness, act of God, natural disaster, adverse weather
                conditions, war, riot, accident, public health concern in
                relation to potential infection, epidemic or pandemic, malicious
                damage, fire, flood and/or storm, compliance with law or
                governmental order, rule, regulation or direction, breakdown of
                plant, machinery, or transportation. SSS are not responsible for
                any loss or damage caused to you as a result of any of these
                occurrences.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                19. The eligibility to participate is solely at the discretion
                of the Company and we reserve the right to block or not accept
                any registration.
              </p>
              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                20. The Company assumes no responsibility for any failure to
                receive participation or for inaccurate information or any loss,
                damage, or injury because of technical or telecommunications
                problems, including security breaches. If such problems arise,
                the Company may (where necessary with the approval of the
                relevant authority) modify, cancel, terminate, or suspend the
                Competition/s.
              </p>

              <p className="text-[15px] mt-[1%] text-[#0000005A] font-semibold">
                  21. Sportspik Champions League
                </p>

                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.1 With the exception of the below deviations, all other
                  responsible gaming from traditional Sportspik apply.
                </p>

                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.2 Unlike normal league based Sportspik competitions, the
                  Champions League version of Sportspik will be initially based
                  on a league system. After the first round of 8 match weeks the
                  game will be based on a knock-out system..
                </p>

                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.3 During the first eight match weeks players will be able
                  to make their selections among the 36 clubs involved.
                </p>
                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.4 After match week eight, match week 9 & 10 will be the two
                  legs of the play-off which will be between the teams who
                  finished 9th -24th in the table. This means that your
                  selections will be restricted to those 16 teams.
                </p>
                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.5 Match week 11 and beyond will be based on the 16 teams
                  that have qualified to the round of 16. These will include the
                  8 top teams after match week 8 in addition to the 8 teams
                  qualified from match week 9 & 10 play-off.
                </p>

                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.6 Regardless of how many picks remain alive the game ends
                  after the second leg of the quarter-finals. The semi-finals
                  and final will not be included in the game.
                </p>
                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.7 Each leg of each play-off & knock out stage will be
                  considered a separate match week. For example leg 1 of the
                  round of 16 is one match week while leg 2 is another.
                </p>

                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.8 Should we have more than one pick remaining after the
                  second leg of the quarter final the jackpot will be
                  distributed equally among the remaining picks
                </p>
                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.9 There could be a situation where players are still alive
                  at the quarter final stage and have no teams to pick from. For
                  Example, the 8 teams who qualified to the quarter final had
                  already been selected in prior match weeks by the player. In
                  this case when a player has no teams available to pick from
                  he/she will be automatically eliminated. Accordingly players
                  must be very careful in making their selections early so as to
                  ensure they have options during the quarter finals.
                </p>
                <p className="text-[15px] mt-[1%] ml-[1%] text-[#0000005A] font-semibold">
                  21.10 Defaults at every stage will be based on the table
                  ranking in the first 8 match weeks. During the play-off &
                  knock-out a default will be assigned based on the lowest rank
                  team playing in these round as per the ranking after match
                  week 8.
                </p>
            </Card> */}

            {/* <Card className="m-auto h-[70vh] font-interFont overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
              <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                Play Responsibly – Stay in Control
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
              </p>
              <h2 className="text-[14px] mt-[3%] text-[#000000] font-semibold">
                  Age Verification – 18+  
                </h2>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
              </p>
              <div class="max-w-2xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6">
                <h2 class="text-2xl font-bold text-gray-800">Keep in Control – Play Smart</h2>
                <p class="text-gray-600">
                  We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                </p>

                <div class="space-y-4">
                  <div class="border-l-4 border-blue-500 pl-4">
                    <h3 class="font-semibold text-gray-700">Play for fun, not for income</h3>
                    <p class="text-sm text-gray-600">Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.</p>
                  </div>

                  <div class="border-l-4 border-green-500 pl-4">
                    <h3 class="font-semibold text-gray-700">Stick to your budget</h3>
                    <p class="text-sm text-gray-600">Never spend more than you can afford to lose. SportsPik sets a <strong className="text-[#000000] font-semibold">max of 200 tokens per round</strong> to support responsible play.</p>
                  </div>

                  <div class="border-l-4 border-red-500 pl-4">
                    <h3 class="font-semibold text-gray-700">Don’t chase losses</h3>
                    <p class="text-sm text-gray-600">Losing is part of the game, don’t try to win it back by playing more.</p>
                  </div>

                  <div class="border-l-4 border-yellow-500 pl-4">
                    <h3 class="font-semibold text-gray-700">Monitor your time</h3>
                    <p class="text-sm text-gray-600">Track how long you play and take regular breaks.</p>
                  </div>

                  <div class="border-l-4 border-purple-500 pl-4">
                    <h3 class="font-semibold text-gray-700">Avoid playing under stress or influence</h3>
                    <p class="text-sm text-gray-600">Gaming while upset or under the influence can lead to poor decisions.</p>
                  </div>

                  <div class="border-l-4 border-pink-500 pl-4">
                    <h3 class="font-semibold text-gray-700">Know when to seek help</h3>
                    <p class="text-sm text-gray-600">If playing stops being fun or starts affecting your life, support is available.</p>
                  </div>
                </div>
              </div>
              <div>
                <h3 class="font-semibold text-gray-700">Timeout </h3>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                </p>
              </div>
              <div>
                <div class="max-w-xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-4">
                  <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                  <ul class="list-disc list-inside text-gray-700 space-y-2">
                    <li>
                      You cannot <span class="font-semibold text-red-600">buy tokens</span> or access your account.
                    </li>
                    <li>
                      You will not receive any <span class="font-semibold text-blue-600">SportsPik marketing communication</span>.
                    </li>
                  </ul>
                </div>
              </div>

            </Card> */}
            {/* <Card className="m-auto h-[70vh] font-interFont overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Play Responsibly – Stay in Control
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
                </p>
                <h2 className="text-[18px] mt-[3%] text-[#000000] font-semibold">
                  Age Verification – 18+  
                </h2>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
                </p>
                
                <div class="pt-3 bg-white  space-y-4">
  <h2 class="text-[22px] text-[#000000] font-semibold">Keep in Control – Play Smart</h2>
  <p class="text-gray-600">
    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
  </p>

  <ul class="list-disc pl-16 space-y-3 text-gray-700 text-[15px]">
    <li>
      <strong>Play for fun, not for income</strong><br />
      Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.
    </li>
    <li>
      <strong>Stick to your budget</strong><br />
      Never spend more than you can afford to lose. SportsPik sets a <strong class="text-black">max of 200 tokens per round</strong> to support responsible play.
    </li>
    <li>
      <strong>Don’t chase losses</strong><br />
      Losing is part of the game, don’t try to win it back by playing more.
    </li>
    <li>
      <strong>Monitor your time</strong><br />
      Track how long you play and take regular breaks.
    </li>
    <li>
      <strong>Avoid playing under stress or influence</strong><br />
      Gaming while upset or under the influence can lead to poor decisions.
    </li>
    <li>
      <strong>Know when to seek help</strong><br />
      If playing stops being fun or starts affecting your life, support is available.
    </li>
  </ul>
</div>

                <div className="pt-3">
                  <h3 class="text-[22px] text-[#000000] font-semibold">Timeout </h3>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                  </p>
                </div>
                <div>
                  <div class="bg-white space-y-4 pt-2">
                    <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                    <ul class="list-disc list-inside text-gray-700 space-y-2">
                      <li>
                        You cannot <span class="font-semibold text-red-600">buy tokens</span> or access your account.
                      </li>
                      <li>
                        You will not receive any <span class="font-semibold text-blue-600">SportsPik marketing communication</span>.
                      </li>
                    </ul>
                  </div>
                </div>

              </Card> */}
            <Card className="m-auto h-[70vh] font-interFont overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
              <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                Play Responsibly – Stay in Control
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
              </p>
              <h2 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                Age Verification – 18+
              </h2>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
              </p>
              {/* <div class="max-w-2xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6">
                  <h2 class="text-2xl font-bold text-gray-800">Keep in Control – Play Smart</h2>
                  <p class="text-gray-600">
                    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                  </p>

                  <div class="space-y-4">
                    <div class="border-l-4 border-blue-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Play for fun, not for income</h3>
                      <p class="text-sm text-gray-600">Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.</p>
                    </div>

                    <div class="border-l-4 border-green-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Stick to your budget</h3>
                      <p class="text-sm text-gray-600">Never spend more than you can afford to lose. SportsPik sets a <strong className="text-[#000000] font-semibold">max of 200 tokens per round</strong> to support responsible play.</p>
                    </div>

                    <div class="border-l-4 border-red-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Don’t chase losses</h3>
                      <p class="text-sm text-gray-600">Losing is part of the game, don’t try to win it back by playing more.</p>
                    </div>

                    <div class="border-l-4 border-yellow-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Monitor your time</h3>
                      <p class="text-sm text-gray-600">Track how long you play and take regular breaks.</p>
                    </div>

                    <div class="border-l-4 border-purple-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Avoid playing under stress or influence</h3>
                      <p class="text-sm text-gray-600">Gaming while upset or under the influence can lead to poor decisions.</p>
                    </div>

                    <div class="border-l-4 border-pink-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Know when to seek help</h3>
                      <p class="text-sm text-gray-600">If playing stops being fun or starts affecting your life, support is available.</p>
                    </div>
                  </div>
                </div> */}
              <div class="pt-3 bg-white  space-y-4">
                <h2 class="text-[22px] text-[#000000] font-semibold">Keep in Control – Play Smart</h2>
                <p class="text-gray-600 text-[17px]">
                  We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                </p>

                <ul class="list-disc pl-16 space-y-3 text-gray-700 text-[17px]">
                  <li>
                    <strong>Play for fun, not for income</strong><br />
                    Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.
                  </li>
                  <li>
                    <strong>Stick to your budget</strong><br />
                    Never spend more than you can afford to lose. SportsPik sets a <strong class="text-black">max of 200 tokens per round</strong> to support responsible play.
                  </li>
                  <li>
                    <strong>Don’t chase losses</strong><br />
                    Losing is part of the game, don’t try to win it back by playing more.
                  </li>
                  <li>
                    <strong>Monitor your time</strong><br />
                    Track how long you play and take regular breaks.
                  </li>
                  <li>
                    <strong>Avoid playing under stress or influence</strong><br />
                    Gaming while upset or under the influence can lead to poor decisions.
                  </li>
                  <li>
                    <strong>Know when to seek help</strong><br />
                    If playing stops being fun or starts affecting your life, support is available.
                  </li>
                </ul>
              </div>

              <div className="pt-3">
                <h3 class="text-[22px] text-[#000000] font-semibold">Timeout </h3>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                </p>
              </div>
              <div>
                <div class="bg-white space-y-4 pt-2">
                  <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                  <ul class="list-disc list-inside text-gray-700 space-y-2 text-[17px]">
                    <li>
                      You cannot buy tokens or access your account.
                    </li>
                    <li>
                      You will not receive any SportsPik marketing communication.
                    </li>
                  </ul>
                </div>
              </div>

            </Card>
            {/* </div> */}
          </div>
          <FooterTab />
        </div>
      ) : (
        <div className="flex flex-col min-h-screen overflow-hidden bg-[url('../public/v2/images/bg/auth-bg.png')] w-full bg-cover">
          <div
            className="flex-1 p-5 font-Inter"
          >
            {!storedUserInfo?.email && (
              <div className="flex p-3 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
                <div className="flex-shrink-0">
                  <img src={pnpLogo} alt="pickNdPrizes" onClick={redirectHome} className="h-20 cursor-pointer"></img>
                </div>
                <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}

            <div>
              <div className={`rules-top ${storedUserInfo?.email ? 'mt-14' : 'mt-10'}`}>
                <h2 className="text-[#FFFFFF] text-[48px] text-center">
                  Responsible Gaming
                </h2>
              </div>

              <Card className="m-auto laptop-s:h-[600px] laptop-l:h-[65vh] desktop:h-[80vh] overflow-auto  pl-16 pt-12 pb-12 pr-16 flex flex-col justify-between w-[95%] my-[1%] bg-[#FFFFFF] shadow-md rounded-[12px] ">
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Play Responsibly – Stay in Control
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik is committed to providing a safe and fun experience for all players. Our games are meant to be simple and exciting, but we understand that gaming can sometimes become a problem for some.
                </p>
                <h2 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  Age Verification – 18+
                </h2>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You must be 18 years of age or older to register for or participate in any SportsPik games or any products offered by SureShotSports FZ-LLC. It is an offence for anyone under 18 to attempt to sign up or participate in games. SportsPik uses advanced technology and manual checks to verify age and identity. If there is any doubt, we may request official documents for verification.
                </p>
                {/* <div class="max-w-2xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6">
                  <h2 class="text-2xl font-bold text-gray-800">Keep in Control – Play Smart</h2>
                  <p class="text-gray-600">
                    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                  </p>

                  <div class="space-y-4">
                    <div class="border-l-4 border-blue-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Play for fun, not for income</h3>
                      <p class="text-sm text-gray-600">Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.</p>
                    </div>

                    <div class="border-l-4 border-green-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Stick to your budget</h3>
                      <p class="text-sm text-gray-600">Never spend more than you can afford to lose. SportsPik sets a <strong className="text-[#000000] font-semibold">max of 200 tokens per round</strong> to support responsible play.</p>
                    </div>

                    <div class="border-l-4 border-red-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Don’t chase losses</h3>
                      <p class="text-sm text-gray-600">Losing is part of the game, don’t try to win it back by playing more.</p>
                    </div>

                    <div class="border-l-4 border-yellow-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Monitor your time</h3>
                      <p class="text-sm text-gray-600">Track how long you play and take regular breaks.</p>
                    </div>

                    <div class="border-l-4 border-purple-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Avoid playing under stress or influence</h3>
                      <p class="text-sm text-gray-600">Gaming while upset or under the influence can lead to poor decisions.</p>
                    </div>

                    <div class="border-l-4 border-pink-500 pl-4">
                      <h3 class="font-semibold text-gray-700">Know when to seek help</h3>
                      <p class="text-sm text-gray-600">If playing stops being fun or starts affecting your life, support is available.</p>
                    </div>
                  </div>
                </div> */}
                <div class="pt-3 bg-white  space-y-4">
                  <h2 class="text-[22px] text-[#000000] font-semibold">Keep in Control – Play Smart</h2>
                  <p class="text-gray-600 text-[17px]">
                    We believe gaming should always remain a form of entertainment. Here are some tips to help you stay in control:
                  </p>

                  <ul class="list-disc pl-16 space-y-3 text-gray-700 text-[17px]">
                    <li>
                      <strong>Play for fun, not for income</strong><br />
                      Gaming isn’t a way to make money. It’s about skill, community, and enjoyment.
                    </li>
                    <li>
                      <strong>Stick to your budget</strong><br />
                      Never spend more than you can afford to lose. SportsPik sets a <strong class="text-black">max of 200 tokens per round</strong> to support responsible play.
                    </li>
                    <li>
                      <strong>Don’t chase losses</strong><br />
                      Losing is part of the game, don’t try to win it back by playing more.
                    </li>
                    <li>
                      <strong>Monitor your time</strong><br />
                      Track how long you play and take regular breaks.
                    </li>
                    <li>
                      <strong>Avoid playing under stress or influence</strong><br />
                      Gaming while upset or under the influence can lead to poor decisions.
                    </li>
                    <li>
                      <strong>Know when to seek help</strong><br />
                      If playing stops being fun or starts affecting your life, support is available.
                    </li>
                  </ul>
                </div>

                <div className="pt-3">
                  <h3 class="text-[22px] text-[#000000] font-semibold">Timeout </h3>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    If you feel you are spending too much time or money on gaming or want to take a longer break, you can request a short break (up to a max of 42 days) to begin on a date and time that suits you, by sending an email to <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                  </p>
                </div>
                <div>
                  <div class="bg-white space-y-4 pt-2">
                    <h2 class="text-xl font-bold text-gray-800">For this period:</h2>
                    <ul class="list-disc list-inside text-gray-700 space-y-2 text-[17px]">
                      <li>
                        You cannot buy tokens or access your account.
                      </li>
                      <li>
                        You will not receive any SportsPik marketing communication.
                      </li>
                    </ul>
                  </div>
                </div>

              </Card>
            </div>
          </div>
          <div className="mt-auto">
            {/* For small devices */}
            <MobileFooter />

            {/* For tablet */}
            <FooterTab componnent="rules" />

            {/* For laptop and larger */}
            <Footer componnent="rules" />
          </div>
        </div>
      )}
    </>
  );
}

export default Rulse;
